<template>
  <v-card class="elevation-1" style="position: relative;">

    <div class="chat-scroll-container" ref="chatContainer">
      <v-layout row wrap v-if="mensajesAMostrar.length > 0">
        <v-flex v-for="mensaje in mensajesAMostrar" :key="mensaje.id" :id="'msg-' + mensaje.id" class="layout xs12 transition-bg"
          style="padding-top:20px; padding-right: 10px; padding-left: 10px; padding-bottom: 10px;">

          <div v-if="isMe(mensaje)" style="margin-right:5px; align-self: end" class="grey--text xs4 flex text-xs-right">
            {{ mensaje.createdNombre }}
            <div>
              <v-icon v-if="mensaje.favorito" size="16" color="primary lighten-1">mdi-star</v-icon>
              <v-icon v-if="mensaje.fijado" size="16" color="primary lighten-1">mdi-pin</v-icon>
              {{ mensaje.autorNombreReal || 'Sistema' }}
            </div>
          </div>

          <v-card
            :class='[isMe(mensaje) ? "xs8 meChat  flex text-left-radius" : "xs8 flex white text-right-radius"]'
            class="elevation-2" style="overflow: hidden;">

            <v-card-text style="padding-left: 15px; padding-right: 15px; padding-top: 10px; padding-bottom:10px;">

              <div v-if="mensaje.eliminado" style="font-style: italic; color: #888;">
                <v-icon small color="grey">mdi-delete</v-icon> Mensaje eliminado
              </div>

              <div v-else>

                <div v-if="mensaje.padreId && getParentMessage(mensaje.padreId)"
                     class="reply-preview"
                     @click="scrollToMessage(mensaje.padreId)">
                  <strong class="primary--text" style="font-size: 0.9em;">
                    {{ getParentMessage(mensaje.padreId).autorNombreReal }}
                  </strong>

                  <div v-if="getParentMessage(mensaje.padreId).eliminado" style="font-style: italic; color: #888; font-size: 0.85em;">
                    <v-icon small color="grey" style="font-size: 14px;">mdi-delete</v-icon> Mensaje eliminado
                  </div>
                  <div v-else class="text-truncate text-padre">
                    {{ getParentMessage(mensaje.padreId).texto }}
                  </div>
                </div>

                <div class="text-formatted">{{ mensaje.texto }}</div>

                <div v-if="mensaje.assets && mensaje.assets.length">
                  <v-divider class="my-2"></v-divider>

                  <div v-if="getImagenes(mensaje.assets).length > 0" class="mb-2">

                    <div class="image-grid-container">
                      <div
                        v-for="(asset, index) in getImagenes(mensaje.assets).slice(0, 4)"
                        :key="asset.id"
                        class="image-grid-item"
                        @click="abrirGaleria(mensaje, asset)"
                      >
                        <v-img :src="asset.url" height="70" class="grey lighten-3 image-cover-fix">
                          <template v-slot:placeholder>
                            <v-layout fill-height align-center justify-center ma-0>
                              <v-progress-circular indeterminate color="grey lighten-1" size="20"></v-progress-circular>
                            </v-layout>
                          </template>
                        </v-img>

                        <div v-if="index === 3 && getImagenes(mensaje.assets).length > 4" class="image-overlay">
                          <span>+{{ getImagenes(mensaje.assets).length - 4 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-for="asset in getOtrosArchivos(mensaje.assets)" :key="asset.id" class="mb-2">

                    <div v-if="esAudio(asset.name)" @click="abrirGaleria(mensaje, asset)" class="chat-audio-preview pa-2 grey lighten-4">
                      <v-icon color="orange darken-1" class="mr-2">audiotrack</v-icon>
                      <span class="text-truncate" style="font-size: 0.9em; flex-grow: 1;">{{ getAttachmentName(asset.name) }}</span>
                      <v-icon small color="grey">play_circle_filled</v-icon>
                    </div>

                    <div v-else-if="esVideo(asset.name)" @click="abrirGaleria(mensaje, asset)" class="chat-audio-preview pa-2 grey lighten-4">
                      <v-icon color="red darken-1" class="mr-2">movie</v-icon>
                      <span class="text-truncate" style="font-size: 0.9em; flex-grow: 1;">{{ getAttachmentName(asset.name) }}</span>
                      <v-icon small color="grey">play_circle_filled</v-icon>
                    </div>

                    <span v-else class="mb-0">
                      <v-icon style="margin-top:10px" small class="mr-1">attach_file</v-icon>
                      <a :href="asset.url" target="_blank" style="text-decoration: none;">
                        {{ getAttachmentName(asset.name) }}
                      </a>
                    </span>

                  </div>
                </div>

              </div>
            </v-card-text>
          </v-card>

          <div v-if="!isMe(mensaje)" style="margin-left:5px; align-self: end;" class="grey--text xs4 flex">
             {{ mensaje.createdNombre }}
            <div>
              <v-icon v-if="mensaje.favorito" size="16" color="primary lighten-1">mdi-star</v-icon>
              <v-icon v-if="mensaje.fijado" size="16" color="primary lighten-1">mdi-pin</v-icon>
              {{ mensaje.autorNombreReal || 'Sistema' }}
              <v-btn v-if="isFromFavoritos || isFromFijado" icon @click="irAlMensajeDesdeChat(mensaje.id)" title="Ir al mensaje">
                <v-icon size="16" color="primary">mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </div>

        </v-flex>
      </v-layout>
      <v-layout v-else>
        <div class="grey--text text-center" style="width: 100%; padding: 20px; font-style: italic;">
          {{isFromFavoritos ? 'No hay mensajes favoritos para mostrar' :  isFromFijado ? 'No hay mensajes fijados para mostrar' : 'No hay mensajes para mostrar'}}
        </div>
      </v-layout>
    </div>

    <v-dialog v-model="dialogoGaleria" max-width="900" dark>
      <v-card class="black" v-if="dialogoGaleria">
        <v-btn icon absolute right style="z-index: 10; top: 10px;" @click="dialogoGaleria = false">
          <v-icon>close</v-icon>
        </v-btn>

        <v-carousel v-model="elementoActualIndex" hide-delimiters height="450" :cycle="false">
          <v-carousel-item v-for="(media, i) in todosLosElementosMultimedia" :key="i">

            <v-layout fill-height align-center justify-center v-if="esImagen(media.name)">
              <img :src="media.url" style="max-height: 100%; max-width: 100%; object-fit: contain;">
            </v-layout>

            <v-layout fill-height align-center justify-center column v-else-if="esAudio(media.name)">
              <v-icon size="100" color="grey darken-3" class="mb-4">audiotrack</v-icon>
              <audio controls :src="media.url" style="width: 70%; outline: none; border-radius: 30px;"></audio>
              <div class="mt-4 grey--text text-truncate" style="max-width: 70%; font-size: 1.1em;">
                {{ getAttachmentName(media.name) }}
              </div>
            </v-layout>

            <v-layout fill-height align-center justify-center v-else-if="esVideo(media.name)">
              <video controls :src="media.url" style="max-height: 100%; max-width: 100%; outline: none;"></video>
            </v-layout>

          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
export default {
  name: 'ChatComentarios',
  props: {
    mensajes: {
      type: Array,
      default: () => []
    },
    isFromFavoritos: {
      type: Boolean,
      default: false
    },
    isFromFijado: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogoGaleria: false,
      elementoActualIndex: 0,
      archivoSeleccionadoId: null
    }
  },
  computed: {
    mensajesAMostrar () {
      if (this.isFromFavoritos) {
        return this.mensajes.filter(m => m.favorito)
      }
      if (this.isFromFijado) {
        return this.mensajes.filter(m => m.fijado)
      }
      return this.mensajes
    },
    mensajeFijado () {
      return this.mensajesAMostrar.find(m => m.fijado)
    },
    todosLosElementosMultimedia () {
      let lista = []
      this.mensajesAMostrar.forEach(mensaje => {
        if (mensaje.assets && mensaje.assets.length > 0) {
          mensaje.assets.forEach(asset => {
            if (this.esMedia(asset.name)) {
              lista.push(asset)
            }
          })
        }
      })
      return lista
    }
  },
  methods: {
    isMe (mensaje) {
      return mensaje.autorNombre === this.$store.state.authUser
    },
    getAttachmentName (name) {
      return name || 'Archivo adjunto'
    },
    esImagen (nombre) {
      if (!nombre) return false
      const ext = nombre.substring(nombre.lastIndexOf('.')).toLowerCase()
      return ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'].includes(ext)
    },
    esAudio (nombre) {
      if (!nombre) return false
      const ext = nombre.substring(nombre.lastIndexOf('.')).toLowerCase()
      return ['.m4a', '.mp3', '.wav', '.ogg', '.aac'].includes(ext)
    },
    esVideo (nombre) {
      if (!nombre) return false
      const ext = nombre.substring(nombre.lastIndexOf('.')).toLowerCase()
      return ['.mp4', '.webm', '.ogg', '.mov'].includes(ext)
    },
    esMedia (nombre) {
      return this.esImagen(nombre) || this.esAudio(nombre) || this.esVideo(nombre)
    },
    abrirGaleria (mensaje, asset) {
      const index = this.todosLosElementosMultimedia.findIndex(item => item.id === asset.id)
      if (index !== -1) {
        this.elementoActualIndex = index
        this.dialogoGaleria = true
      }
    },
    getParentMessage (padreId) {
      return this.mensajes.find(m => m.id === padreId)
    },
    scrollToMessage (id) {
      const el = document.getElementById('msg-' + id)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        el.classList.add('highlight-flash')
        setTimeout(() => {
          el.classList.remove('highlight-flash')
        }, 2000)
      }
    },
    scrollToBottom () {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer
        if (container) {
          container.scrollTo({
            top: container.scrollHeight,
            behavior: 'smooth'
          })
        }
      })
    },
    getImagenes (assets) {
      return assets.filter(asset => this.esImagen(asset.name))
    },
    getOtrosArchivos (assets) {
      return assets.filter(asset => !this.esImagen(asset.name))
    },
    irAlMensajeDesdeChat (mensajeId) {
      this.$emit('irAlMensaje', mensajeId)
    }
  },
  mounted () {
    this.scrollToBottom()
  },
  watch: {
    mensajesAMostrar: {
      handler (newVal, oldVal) {
        if (oldVal) {
          if (newVal.length !== oldVal.length) {
            this.scrollToBottom()
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.chat-scroll-container {
  max-height: 500px;
  min-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fafafa;
}

.chat-media-preview {
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  margin-top: 5px;
  border: 1px solid rgba(0,0,0,0.1);
}

.chat-audio-preview {
  display: flex;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 5px;
  border: 1px solid rgba(0,0,0,0.1);
  transition: background-color 0.2s;
}

.chat-audio-preview:hover {
  background-color: #eeeeee !important;
}

.reply-preview {
  background-color: rgba(0, 0, 0, 0.05);
  border-left: 4px solid #1976D2;
  padding: 6px 10px;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;
}
.text-padre {
  font-size: 0.85em;
  color: #555;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-formatted {
  white-space: pre-wrap;
  word-break: break-word;
}

.transition-bg {
  transition: background-color 0.5s ease;
}
.highlight-flash {
  background-color: rgba(25, 118, 210, 0.15) !important;
}

.chat-scroll-container::-webkit-scrollbar {
  width: 6px;
}
.chat-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}
.chat-scroll-container::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}
.chat-scroll-container::-webkit-scrollbar-thumb:hover {
  background: transparent;
}

.text-left-radius {
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  border-top-right-radius: 10px;
}
.text-right-radius {
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  border-top-left-radius: 10px;
}
/* Estilos para la grilla compacta de imágenes en el chat */
.image-grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 2 columnas lado a lado */
  gap: 4px; /* Espacio pequeño entre las fotos */
  border-radius: 6px;
  overflow: hidden;
}

.image-grid-item {
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
}

/* Capa oscura (ofuscada) para la última miniatura cuando hay más de 4 */
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  font-weight: bold;
}
.image-cover-fix img {
  object-fit: cover !important;
  height: 85px !important;
}
</style>
